<div
  class="plan-v2-issue-actions-wrap"
  [class.plan-v2-issue-actions-wrap--compose]="composeMode"
  [class.plan-v2-issue-actions-wrap--technical-compose]="isTechnicalCompose || isTopicOwnershipCompose"
  [class.plan-v2-issue-actions-wrap--topic-compose]="isTopicOwnershipCompose"
>
  <div
    class="plan-v2-issue-actions"
    [class.plan-v2-issue-actions--compact]="compact"
    [class.plan-v2-issue-actions--exit-work]="animatingOut === 'work_item'"
    [class.plan-v2-issue-actions--exit-dismiss]="animatingOut === 'dismissed'"
    *ngIf="showInIssuesEmbed || queue === 'work_item'"
  >
    <ng-container *ngIf="showInIssuesEmbed && !composeMode">
      <button
        type="button"
        class="plan-v2-issue-btn plan-v2-issue-btn--muted"
        (click)="dismissIssue($event)"
        [disabled]="updating"
      >
        Dismiss
      </button>
      <button
        type="button"
        class="plan-v2-issue-btn plan-v2-issue-btn--work"
        (click)="sendToWorkItems($event)"
        [disabled]="updating"
      >
        Work item
      </button>
    </ng-container>
    <button
      *ngIf="queue === 'work_item'"
      type="button"
      class="plan-v2-issue-btn plan-v2-issue-btn--muted"
      (click)="returnToIssues($event)"
      [disabled]="updating"
    >
      Back to issues
    </button>
  </div>

  <div
    class="plan-v2-compose-actions plan-v2-compose-actions--topic-ownership"
    *ngIf="composeMode === 'topic_ownership'"
    (click)="$event.stopPropagation()"
  >
    <button type="button" class="plan-v2-issue-btn plan-v2-issue-btn--muted" (click)="cancelCompose($event)">
      Cancel
    </button>
    <button
      type="button"
      class="plan-v2-issue-btn plan-v2-issue-btn--work"
      (click)="confirmCompose($event)"
      [disabled]="updating"
    >
      Add to work items
    </button>
  </div>

  <div
    class="plan-v2-compose"
    [class.plan-v2-compose--replaces-card]="isTechnicalCompose || isInternalLinkCompose"
    *ngIf="composeMode && composeMode !== 'topic_ownership'"
    (click)="$event.stopPropagation()"
  >
    <p class="plan-v2-compose-title">
      <ng-container *ngIf="composeMode === 'technical_critical'">Which issues should we fix?</ng-container>
      <ng-container *ngIf="composeMode === 'technical_warnings'">Which warnings should we fix?</ng-container>
      <ng-container *ngIf="composeMode === 'serp_phrase'">Review work item</ng-container>
      <ng-container *ngIf="composeMode === 'internal_link'">Which links should we add?</ng-container>
    </p>

    <div class="plan-v2-compose-gaps plan-v2-compose-gaps--links" *ngIf="isInternalLinkCompose">
      <label class="plan-v2-compose-gap" *ngFor="let opt of internalLinkOptions">
        <input type="checkbox" [(ngModel)]="opt.selected" [name]="'link-' + opt.id" />
        <span class="plan-v2-compose-gap-body">
          <div class="internal-link-row-chips">
            <span class="internal-link-direction-chip" [ngClass]="internalLinkDirectionChipClasses(opt)">{{
              internalLinkDirectionChip(opt)
            }}</span>
            <span class="internal-link-relevance-chip"
              >Relevance {{ formatInternalLinkScore(opt.score) }}</span
            >
          </div>
          <a
            class="plan-v2-compose-gap-path plan-v2-compose-gap-page-link"
            [href]="opt.pageUrl"
            target="_blank"
            rel="noopener noreferrer"
            (click)="$event.stopPropagation()"
            (mousedown)="$event.stopPropagation()"
            >{{ opt.pagePath }}</a
          >
          <span class="plan-v2-compose-gap-placement muted" *ngIf="opt.placement">
            <ng-container *ngIf="opt.placementParts as parts; else placementPlain">
              “{{ parts.before }}<a
                class="plan-v2-compose-placement-link"
                [href]="opt.linkHref"
                target="_blank"
                rel="noopener noreferrer"
                (click)="$event.stopPropagation()"
                (mousedown)="$event.stopPropagation()"
                >{{ parts.anchor }}</a
              >{{ parts.after }}”
            </ng-container>
            <ng-template #placementPlain>
              “{{ opt.placement }}”
              <a
                *ngIf="opt.row.suggestedAnchor?.trim()"
                class="plan-v2-compose-placement-link plan-v2-compose-placement-link--fallback"
                [href]="opt.linkHref"
                target="_blank"
                rel="noopener noreferrer"
                (click)="$event.stopPropagation()"
                (mousedown)="$event.stopPropagation()"
                >{{ opt.row.suggestedAnchor.trim() }}</a
              >
            </ng-template>
          </span>
        </span>
      </label>
    </div>

    <div class="plan-v2-compose-gaps plan-v2-compose-gaps--technical" *ngIf="isTechnicalCompose">
      <div class="plan-v2-compose-technical-group" *ngFor="let opt of technicalOptions">
        <label class="plan-v2-compose-gap plan-v2-compose-gap--parent">
          <input
            type="checkbox"
            [checked]="technicalParentIsChecked(opt)"
            [name]="'tech-parent-' + opt.id"
            (change)="onTechnicalParentChange(opt, $event)"
          />
          <span class="plan-v2-compose-gap-body">
            <span class="plan-v2-compose-gap-path">{{ opt.title }}</span>
          </span>
        </label>
        <div class="plan-v2-compose-technical-details" *ngIf="technicalHasSelectableDetails(opt)">
          <ng-container *ngFor="let det of opt.detailOptions">
            <label class="plan-v2-compose-gap plan-v2-compose-gap--detail" *ngIf="det.selectable">
              <input
                type="checkbox"
                [(ngModel)]="det.selected"
                [name]="'tech-det-' + det.id"
                (ngModelChange)="onTechnicalDetailChange(opt)"
              />
              <span class="plan-v2-compose-gap-body">
                <span class="plan-v2-compose-gap-meta">{{ det.text }}</span>
              </span>
            </label>
          </ng-container>
          <div class="plan-v2-compose-technical-meta muted">
            <p *ngFor="let det of opt.detailOptions">
              <ng-container *ngIf="!det.selectable">{{ det.text }}</ng-container>
            </p>
          </div>
        </div>
        <div
          class="plan-v2-compose-technical-meta muted"
          *ngIf="!technicalHasSelectableDetails(opt) && opt.detailOptions.length"
        >
          <p *ngFor="let det of opt.detailOptions">{{ det.text }}</p>
        </div>
      </div>
    </div>

    <app-plan-v2-work-item-body
      class="plan-v2-compose-preview"
      *ngIf="!isCheckboxCompose"
      [item]="composePreviewRecord()"
    />

    <div class="plan-v2-compose-actions">
      <button type="button" class="plan-v2-issue-btn plan-v2-issue-btn--muted" (click)="cancelCompose($event)">
        Cancel
      </button>
      <button
        type="button"
        class="plan-v2-issue-btn plan-v2-issue-btn--work"
        (click)="confirmCompose($event)"
        [disabled]="updating"
      >
        Add to work items
      </button>
    </div>
  </div>
</div>
